export const LOADING_STATUS = {
  load: 'LOAD',
  done: 'DONE',
  error: 'ERROR'
} as const;

export type LoadingStatusKeys = keyof typeof LOADING_STATUS;
export type LoadingStatus = typeof LOADING_STATUS[LoadingStatusKeys];
